import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchSubscriptionStatus, updateSubscriptionStatus } from "../api/emailSubscriptions";
import SubscriptionDisplay from "src/components/EmailSubscription/SubscriptionDisplay";
import StatusBackground from "src/components/StatusBackground";

// Helper to get query param from URL
function getTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get("token");
}

const Subscription = () => {
  const { t } = useTranslation();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  const accessToken = getTokenFromUrl();

  useEffect(() => {
    const getSubscription = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchSubscriptionStatus(accessToken);
        setSubscription(data);
      } catch (err) {
        setError(err.message || t('subscription.errors.fetchFailed'));
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) {
      getSubscription();
    } else {
      setError(t('subscription.errors.noToken'));
      setLoading(false);
    }
  }, [accessToken, t]);

  const handleToggle = async () => {
    if (!subscription) return;
    setUpdating(true);
    setError(null);
    try {
      const newStatus = !subscription.subscribed;
      const data = await updateSubscriptionStatus(accessToken, newStatus);
      setSubscription(data);
    } catch (err) {
      setError(err.message || t('subscription.errors.updateFailed'));
    } finally {
      setUpdating(false);
    }
  };

  return (
    <StatusBackground>
      <SubscriptionDisplay
        loading={loading}
        error={error}
        email={subscription?.email || ""}
        subscribed={subscription?.subscribed || false}
        updating={updating}
        onToggle={handleToggle}
      />
    </StatusBackground>
  );
};

export default Subscription;
